import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'

export const Options = styled.div`
    display: flex;
    gap: 4px;
    width: 100%;

    > button {
        background: ${giphyDarkestGrey};
    }
`
